import { ItemTitle } from '@sleepstation/components'
import { CopyParagraph } from '@sleepstation/components-copy'
import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import { propEq } from 'ramda'
import React from 'react'
import { useRouteError } from 'react-router-dom'
import { useMount } from 'react-use'
import NotFoundError from '../../errors/NotFoundError'
import PageError from '../../errors/PageError'
import { isDevelopmentBuild } from '../../helpers/environment'
import getErrorReporter from '../../init/getErrorReporter'
import { getPageData } from '../../utils/routing'
import DefaultPage from '../pages/DefaultPage'
import ConstrainedCopy from '../shared/ConstrainedCopy'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const getIs404 = propEq(404, `status`)

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const ErrorPageModule = () => {
  const error = useRouteError()
  const errorReporter = getErrorReporter()
  errorReporter.send(new Error(`Error loading page`), {
    reporterCalledFrom: `ErrorPageModule`,
    originalError: error,
  })

  const data = getPageData(`error`, { error })

  const {
    page: { content },
  } = data

  const shouldShowErrorInfo = isDevelopmentBuild()

  // If it's React Router's ErrorResponseImpl, it will have an 'error' prop,
  // otherwise it will be the error itself.
  const errorObj = error.error || error

  useMount(() => {
    const reportedError = getIs404(error)
      ? new NotFoundError()
      : new PageError(error)

    errorReporter.send(reportedError, {
      reporterCalledFrom: `ErrorPageModule`,
    })
  })

  return (
    <DefaultPage data={data}>
      <CopyRenderer
        dataCy="error-explanation"
        htmlAst={content.copy.body}
        CopyComponent={ConstrainedCopy}
      />
      {shouldShowErrorInfo && (
        <ConstrainedCopy>
          <ItemTitle>{errorObj.toString()}</ItemTitle>
          {error.stack && (
            <CopyParagraph>{error.stack.toString()}</CopyParagraph>
          )}
        </ConstrainedCopy>
      )}
    </DefaultPage>
  )
}

export default ErrorPageModule
